module.exports = __webpack_public_path__ + "img/iruka-round.21fb9a7a.png";